import { CloseRounded } from "@mui/icons-material";
import { Grid, IconButton, Paper } from "@mui/material";
import { action, API, controller } from "api";
import { Button, Input } from "controls";
import { Model, ToFormData, UseForm } from "hooks";
import { Form } from "layout";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const AddEditCurr = (props) => {
  const { setAlert, setShowForm, updData, setCurrs } = props;
  const { CurrencyMdl } = Model();
  const [loading, setLoading] = useState(false);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(CurrencyMdl);

  useEffect(() => {
    updData &&
      setValues((x) => ({
        ...x,
        ...updData,
        createUser: "",
        lastUpdateUser: "",
        currency: "",
        date: "",
        user: "",
      }));
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const validateForm = () => {
    let temp = {};
    temp.symbol = values.symbol !== "" ? "" : "Symbol is required.";
    temp.shortName = values.shortName !== "" ? "" : "Short name is required.";
    temp.fullName = values.fullName !== "" ? "" : "Name is required.";
    temp.allowDecimal =
      values.allowDecimal !== "" ? "" : "Allow decimal is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          updData
            ? setCurrs((x) => [
                ...x.map((j) => (j.id === res.result.id ? res.result : j)),
              ])
            : setCurrs((x) => [res.result, ...x]);
          toast.success(res?.msg);
          setShowForm(false);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      if (values.id === 0)
        API(controller.Currency + action.Post).post(
          ToFormData({ ...values }),
          onComplete
        );
      else
        API(controller.Currency + action.Put).put(
          ToFormData({ ...values }),
          onComplete
        );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="flex flex-wrap justify-between p-[8px] gap-3 items-center border-b mb-[10px]">
            <span className="text-[18px] font-medium text-gray-600 uppercase ml-[3px] tracking-wider">
              {updData ? "Update" : "Add"} Currency
            </span>
            <div>
              <IconButton
                size="small"
                className="p-0 !mr-[5px]"
                onClick={handleClose}
              >
                <CloseRounded />
              </IconButton>
            </div>
          </div>

          <div className="p-[10px]">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Input
                  label="Full Name"
                  name="fullName"
                  value={values.fullName}
                  error={errors.fullName}
                  required={true}
                  inputProps={{ maxLength: 150 }}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label="Symbol"
                  name="symbol"
                  value={values.symbol}
                  error={errors.symbol}
                  required={true}
                  inputProps={{ maxLength: 10 }}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <Input
                  label="Short Name"
                  name="shortName"
                  value={values.shortName}
                  error={errors.shortName}
                  required={true}
                  inputProps={{ maxLength: 50 }}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label="Allow Decimal"
                  name="allowDecimal"
                  value={values.allowDecimal}
                  error={errors.allowDecimal}
                  required={true}
                  maxLength={5}
                  onChange={handleInpChg}
                  type="number"
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <Input
                  label="Currency Unit"
                  name="currencyUnit"
                  value={values.currencyUnit}
                  error={errors.currencyUnit}
                  inputProps={{ maxLength: 50 }}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12}>
                <div className="flex gap-2 mt-[10px]">
                  <Button
                    className="!uppercase"
                    variant="text"
                    onClick={handleClose}
                    fullWidth
                  >
                    Close
                  </Button>
                  <Button
                    className="!uppercase"
                    fullWidth
                    loading={loading}
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Form>
    </>
  );
};

export default AddEditCurr;
